import isPropValid from '@emotion/is-prop-valid';

type ExcludeList = string[];

export const shouldForwardProp = (...exclude: ExcludeList) => (prop: string) => {
  return isPropValid(prop) && !exclude.includes(prop);
};